import Dexie from 'dexie';

// Pre-1.0 builds used the name 'LabAppDB'; the rename orphaned that database
// on upgraded devices. Deleting reclaims the storage and is a no-op once gone.
Dexie.delete('LabAppDB').catch(() => {});

export const db = new Dexie('SqueakBaseDB');

db.version(1).stores({
  mice: 'id, physical_tag, sex, status, cage_id, user_id, updated_at, strain_id', // Primary key is id (mixed string/number)
  cages: 'id, display_cage_number, location, status, user_id, updated_at',
  syncQueue: '++id, action, endpoint, payload, tempId, timestamp', // Queue for offline mutations
  kv: 'key', // Key-Value store for metadata (lastSync, etc.)
  strains: 'id, strain_name',
  locus: 'id, locus_name',
  allele: 'id, allele_name',
});

db.version(2).stores({
  litters: 'id, cage_id, status, user_id, updated_at',
});

db.version(3).stores({
  failedSync: '++id, action, endpoint, table, timestamp',
});

// C5: pregnancies were the one entity with no local table. Every pregnancy call
// went straight to axios, so the cage pregnancy modals failed silently offline
// in an app that is offline-first everywhere else.
db.version(4).stores({
  pregnancies: 'id, cage_id, mother_id, status, updated_at',
});

// Helper to get last sync time
export async function getLastSyncTime() {
  const record = await db.kv.get('lastSync');
  return record ? record.value : null;
}

// Helper to set last sync time
export async function setLastSyncTime(isoString) {
  await db.kv.put({ key: 'lastSync', value: isoString });
}
